<template>
  <div class="main-top-nav">
    <router-link class="nav-link" :to="{name: 'DashboardMain'}">
      <img :src="require('@/assets/imgs/topNav/LOGO.png')" alt="" />
      <h1>臺虎精釀 Taihu Brewing</h1>
    </router-link>

    <b-dropdown class="nav-dropdown" right no-caret variant="link" v-if="hasToken">
      <template v-slot:button-content>
        <div class="d-flex align-items-center">
          <span class="nav-user-level mr-2">{{ userLevelTitle }}</span>
          <b-icon icon="chevron-down"></b-icon>
        </div>
      </template>

      <b-dropdown-item @click.prevent="logout">登出</b-dropdown-item>
    </b-dropdown>

    <b-button class="toggle-btn" @click="sideBarToggle" v-if="isAdmin">
      <b-icon icon="list"></b-icon>
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MainTopNav',
  data() {
    return {
      READ_INFO_BUSY: 'READ_INFO_BUSY',
    };
  },
  components: {
  },
  computed: {
    ... mapGetters(['isMobileSideBarShow']),
    ... mapGetters('auth', ['hasToken', 'userData']),
    isAdmin() {
      return this.hasToken && this.userData.is_admin;
    },
    userLevelTitle() {
      // return this.isAdmin? '管理員': '使用者';
      return this.userData.name;
    }
  },
  async mounted() {
    if (!this.$store.getters['auth/userData']) {
      await this.readInfo();
    }
  },
  methods: {
    async readInfo() {
      this.$store.dispatch('appendComponentBusy', this.READ_INFO_BUSY);
      try {
        const infoRes = await this.$store.dispatch('api/getAccountInfoPromise');
        this.$store.dispatch('auth/updateUser', infoRes);
      } catch (error) {
        this.$store.dispatch('showMsg', error.toString());
      } finally {
        this.$store.dispatch('clearComponentBusy', this.READ_INFO_BUSY);
      }
    },
    logout() {
      const r = confirm('確定登出嗎?');
      if (r) {
        this.$store.dispatch('auth/loggedOut');
        this.$router.push({
          name: 'Login'
        });
      }
    },
    sideBarToggle() {
      console.log(!this.isMobileSideBarShow);
      this.$store.dispatch('setMobileSideBarShow', !this.isMobileSideBarShow);
    }
  },
}
</script>

<style lang="scss">
@import "src/assets/scss/basic";
  .main-top-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    border-bottom: 1px solid $color-border;
    padding: 8px 16px;
    position: relative;
    .nav-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      column-gap: .5rem;
      color: $color-primary;
      >img {
        height: 2rem;
      }
      >h1 {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0;
        padding: 0;
      }
      &:hover {
        color: $color-primary;
      }
    }
  
    .nav-dropdown {
      .nav-user-level {
        border: solid 1px $color-black-600;
        color: $color-black-600;
        padding: 6px 12px;
        border-radius: 999px;
      }
      button.btn {
        padding: .5rem 1rem;
        &:focus {
          box-shadow: none;
        }
        &.dropdown-toggle {
          display: flex;
          align-items: center;
          text-decoration: none;
        }
      }
      
    }
  
    a:hover, a:focus {
      text-decoration: none;
    }

    .toggle-btn {
      display: none;
    }
    @include smaller-than-medium() {
      padding: .25rem .5rem;
      padding-left: 1.5rem;
      .nav-link {
        >img {
          height: 1rem;
        }
        >h1 {
          font-size: .8rem;
        }
      }
    
      .nav-dropdown {
        .nav-user-level {
          font-size: .6rem;
        }
        button.btn {
          padding: .5rem 0;
        }
      }

      .toggle-btn {
        position: absolute;
        display: block;
        padding: .25rem .5rem;
        font-size: .6rem;
        background-color: transparent;
        top: 50%;
        left: .5rem;
        transform: translate(0, -50%);
        >svg {
          margin: 0;
        }
      }
    }
  }

</style>